<template>
  <div
    class="h-screen flex items-center justify-center "
    :class="{'dark': isDarkTheme}"
  >
    <div class="flex flex-col justify-center items-center">
      <aha-logo
        width="156"
        height="26"
        viewBox="0 0 9600 1602"
        class="mb-6 logo-dark"
      />
      <p class="text-center w-80 mb-6">
        Use live <b>polls, word clouds, Q&As</b> and more to create incredible,
        interactive fun in your meetings!
      </p>
      <div class="flex justify-center flex-col">
        <aha-button @click="openLoginWindow" size="lg" class="w-44 mb-4">
          Log in
        </aha-button>
        <aha-button
          @click="openSignupWindow"
          size="lg"
          variant="white"
          class="w-44"
        >
          Sign up for free
        </aha-button>
      </div>
    </div>
  </div>
</template>

<script>
import { authentication } from '@microsoft/teams-js'
import config from '@/config'
import cookie from '@/services/cookie'
import EventBus from '@/eventBus'
import msTeamsUtils from '@/utils/ms-teams'

export default {

  props: {

  },
  data() {
    return {
      isDarkTheme: false,
    }
  },

  mounted() {
    authentication.initialize()

    if (cookie.getValue('ahaToken')) {
      this.$router.replace({ name: 'MSTeams-TabConfig' })
    }
  },
  async created() {
    const isDarkTheme = await msTeamsUtils.isDarkThemeInMsTeams()
    this.isDarkTheme = isDarkTheme
  },

  methods: {
    async openLoginWindow() {
      const self = this
      authentication.authenticate({
        url: `${config.presenterDomain}/pages/login?ms_teams=true`,
        width: 540,
        height: 720,
        successCallback: self.onLoginSuccess,
      })
    },
    onLoginSuccess(token) {
      EventBus.$emit('ms-teams-login-success', token)
    },
    openSignupWindow() {
      const self = this
      authentication.authenticate({
        url: `${config.presenterDomain}/pages/register?ms_teams=true`,
        width: 540,
        height: 720,
        successCallback: self.onSignupSuccess,
      })
    },
    onSignupSuccess(token) {
      EventBus.$emit('ms-teams-login-success', token)
    },
  },
}
</script>
<style lang="scss" >
.dark {
  background:  black;
  color : #AFAFAF;
  h2,h3,p {
    color : #EBEBEB;
  }
  .text-secondary-100{
    color: #AFAFAF;
  }
  path[fill='#404658'] {
    fill: white!important;
  }
  .text-dark-theme {
    color : #AFAFAF;
  }
  .border-secondary-20{
    border-color : #AFAFAF;
  }
  .path-fill-current path{
    fill: #F1F0F9;
  }
  .icon-container--circle{
    background : #707070;
  }
  .icon-container--lg{
    background: #7669BF;
  }

}
.dark-folder {
  background:  #313131;
  border: 1px solid #3F4557;
  .text-dark-theme {
    color : #AFAFAF;
  }
  .text-light-in-dark-theme{
    color : white;
  }
}
</style>
